import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BadgeOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';

import {
    StyledPurpleContainer,
    StyledTwoScreensWrapper,
} from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '@/operator/components/modules/AuthPage/setup/MessageWithTipMui';

import OnboardingContent from './OnboardingContent';
import useAuth, { AuthProvider } from 'Modules/firebase/use-auth';

type DescriptionProps = {
    isGoogleUser: boolean;
};
const Description = ({ isGoogleUser }: DescriptionProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="body1" style={{ color: '#5B5B5B' }}>
                {t(
                    `Auth.Setup.OnboardingInvite.Content.${
                        isGoogleUser ? 'Google' : 'EmailAndPassword'
                    }.Description`,
                )}
            </Typography>
            <Typography variant="body1" style={{ color: '#5B5B5B' }}>
                {t(
                    `Auth.Setup.OnboardingInvite.Content.${
                        isGoogleUser ? 'Google' : 'EmailAndPassword'
                    }.SecondDescription`,
                )}
            </Typography>
        </>
    );
};

const OnboardingInvitePage = (): JSX.Element | null => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const isGoogleUser = useMemo(
        () => Boolean(user?.provider === AuthProvider.google),
        [user],
    );

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTipMui
                Icon={BadgeOutlined}
                headline={t('Auth.Setup.OnboardingInvite.Content.Header')}
                description={<Description isGoogleUser={isGoogleUser} />}
            />

            <StyledPurpleContainer>
                <OnboardingContent />
            </StyledPurpleContainer>
        </StyledTwoScreensWrapper>
    );
};

export default OnboardingInvitePage;
